import { Box, Button, ButtonAppearance, TextArea } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { fullHDFormWidth, fullHDScreenWidth } from '~/utilities';

export const TextAreaStyled = styled(TextArea)`
  ${({ theme }) => css`
    padding: ${theme.spacings[400]} ${theme.spacings[500]} ${theme.spacings[500]};
    &:disabled {
      background: ${theme.colors.grey[100]};
    }
  `}
`;

export const CopyButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.SECONDARY,
})`
  min-width: 150px;
  justify-content: space-evenly;
  ${({ theme }) => css`
    color: ${theme.colors.primary[700]};
    padding: 0 ${theme.spacings[500]};
    font-weight: ${theme.fontWeights[600]};
  `}
`;

export const ClearButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.SECONDARY,
})`
  min-width: 100px;
  justify-content: space-evenly;
  box-shadow: 0;
  border: 0;
  ${({ theme }) => css`
    color: ${theme.colors.red[700]};
    padding: 0 ${theme.spacings[500]};
    font-weight: ${theme.fontWeights[600]};
    background: ${theme.colors.grey[100]};
  `}
`;

export const ValueCountStyled = styled(Box)`
  position: absolute;
  ${({ theme }) => css`
    right: ${theme.spacings[700]};
    bottom: 14px;
  `}
`;

export const HRStyled = styled.div`
  height: 1px;
  ${({ theme }) => css`
    border-bottom: 1px dashed ${theme.colors.grey[400]};
  `}
`;

export const NotesBoxStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: 1 },
})`
  overflow-y: 'auto';
  width: 100%;
  margin: auto;
  @media only screen and (min-width: ${fullHDScreenWidth}) {
    width: ${fullHDFormWidth};
  }
`;
